import { AvailableRoomPlan } from '@/__generated';
import { BoardType } from '@/constants';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';

type Props = {
  planDetail: AvailableRoomPlan;
  supplier: string | undefined | null;
};

export default function RoomPlanMealDetail({ planDetail, supplier }: Props) {
  const ref = React.useRef<any>();
  const hasBreakfastDetails = React.useMemo(() => {
    if ([BoardType.__getValue(BoardType.BreakfastIncl), BoardType.__getValue(BoardType.DinnerAndBreakfastIncl)].includes(planDetail.boardType)) {
      let detail = supplier === 'NTA' ? planDetail.breakfastDetails : '';
      return planDetail.breakfastName || planDetail.breakfastPlace || detail;
    }
    return null;
  }, [planDetail, supplier]);
  const hasDinnerDetails = React.useMemo(() => {
    if ([BoardType.__getValue(BoardType.DinnerOnly), BoardType.__getValue(BoardType.DinnerAndBreakfastIncl)].includes(planDetail.boardType)) {
      let detail = supplier === 'NTA' ? planDetail.breakfastDetails : planDetail.dinnerMainDish;
      return planDetail.dinnerName || planDetail.dinnerPlace || detail;
    }

    return null;
  }, [planDetail, supplier]);

  if (!hasBreakfastDetails && !hasDinnerDetails) {
    return null;
  }
  return (
    <div>
      <FontAwesomeIcon ref={ref} icon={faCircleInfo} className="text-blue-1 ml-5" style={{ cursor: 'pointer' }} />

      <UncontrolledPopover popperClassName="w-500px" placement="bottom" target={ref as any} trigger="focus">
        <PopoverHeader>Meal details</PopoverHeader>
        <PopoverBody>
          <div className="text-14">
            {hasBreakfastDetails ? (
              <div className="y-gap-6">
                <div className="text-14 text-blue-1 fw-600 pb-4 mb-10" style={{ borderBottom: '1px solid' }}>
                  Breakfast
                </div>
                {planDetail.breakfastName ? (
                  <div className="d-flex  mt-4">
                    <div className="text-light-1" style={{ minWidth: 80 }}>
                      Name:
                    </div>
                    <div className="fw-600">{planDetail.breakfastName}</div>
                  </div>
                ) : null}
                {planDetail.breakfastPlace ? (
                  <div className="d-flex mt-4">
                    <div className="text-light-1" style={{ minWidth: 80 }}>
                      Place:
                    </div>
                    <div className="fw-600">{planDetail.breakfastPlace}</div>
                  </div>
                ) : null}
                {planDetail.breakfastDetails && supplier === 'NTA' ? (
                  <div className="d-flex mt-4">
                    <div className="text-light-1" style={{ minWidth: 80 }}>
                      Details:
                    </div>
                    <div className="fw-600 flex-1" dangerouslySetInnerHTML={{ __html: planDetail.breakfastDetails }}></div>
                  </div>
                ) : null}
              </div>
            ) : null}
            {hasDinnerDetails ? (
              <div className="y-gap-6 mt-10">
                <div className="text-14 text-blue-1 fw-600 pb-4 mb-10" style={{ borderBottom: '1px solid' }}>
                  Dinner
                </div>
                {planDetail.dinnerName ? (
                  <div className="d-flex  mt-4">
                    <div className="text-light-1" style={{ minWidth: 80 }}>
                      Name:
                    </div>
                    <div className="fw-600">{planDetail.dinnerName}</div>
                  </div>
                ) : null}
                {planDetail.dinnerPlace ? (
                  <div className="d-flex mt-4">
                    <div className="text-light-1" style={{ minWidth: 80 }}>
                      Place:
                    </div>
                    <div className="fw-600">{planDetail.dinnerPlace}</div>
                  </div>
                ) : null}

                {supplier === 'NTA' ? (
                  <>
                    {planDetail.dinnerDetails ? (
                      <div className="d-flex mt-4">
                        <div className="text-light-1" style={{ minWidth: 80 }}>
                          Details
                        </div>
                        <div className="fw-600 flex-1" dangerouslySetInnerHTML={{ __html: planDetail.dinnerDetails }}></div>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <>
                    {planDetail.dinnerMainDish ? (
                      <div className="d-flex mt-4">
                        <div className="text-light-1" style={{ minWidth: 80 }}>
                          Main Dish:
                        </div>
                        <div className="fw-600 flex-1" dangerouslySetInnerHTML={{ __html: planDetail.dinnerMainDish }}></div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            ) : null}
          </div>
        </PopoverBody>
      </UncontrolledPopover>
    </div>
  );
}
